import Graph from '../Graph'
import { Point } from 'Vectorgraph/Point'
import { getBorderBreaks, setSectionTo } from 'Vectorgraph'
import { STSGraph } from './STS'
import { useSettings } from 'Settings'
import ValueTransform from 'ValueTransform'

const getBorderBreakInSection = (graph, from, to, border, top) => {
	const breaks = getBorderBreaks(graph, border, top)

	return breaks.find((p) => p[0] >= from && p[0] <= to)
}

const BatLow = (props) => {
	const [settings] = useSettings()
	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)
	const v_bat_min_hi_con = ValueTransform(settings['supervisory level']['v_bat_min_hi_con'].value, acc)

	let graph = []
	const sts = STSGraph()

	graph.push(Point(0, 0))

	getBorderBreaks(sts, v_bat_min_hi_dis, true).forEach(([start, end]) => {
		if (end < 4 && end > 3)
			end = 4
		graph.push(Point(start, 0))
		graph.push(Point(start, 1))
		graph.push(Point(end, 1))
		graph.push(Point(end, 0))
	})

	graph.push(Point(9, 0))

	getBorderBreaks(sts, v_bat_min_hi_con, true).forEach(([start, end]) => {
		if (start < 2)
			start = 2

		if (end < 2)
			return

		graph = setSectionTo(graph, start, end, 0)
	})

	const bb = getBorderBreakInSection(sts, 4, 5, v_bat_min_hi_dis, true)

	graph = setSectionTo(graph, bb[0], 5.5, 1)

	const bb2 = getBorderBreakInSection(sts, 7, 8, v_bat_min_hi_con, false)
	graph = setSectionTo(graph, bb2[0], 8, 1)


	return (
		<Graph {...props} points={graph} />
	)
}

export default BatLow
